import React__default from 'react';
import PropTypes from 'prop-types';

var Mailto = function Mailto(_ref) {
  var emailAddress = _ref.emailAddress;
  return /*#__PURE__*/React__default.createElement("a", {
    href: "mailto:" + emailAddress
  }, emailAddress);
};
Mailto.displayName = "Mailto";
Mailto.propTypes = {
  emailAddress: PropTypes.string.isRequired
};

export { Mailto, Mailto as default };
